export function getDisplayName(name: string) {
    const maxLength = 30;
    if (name.length <= maxLength) return name;
    return name.substr(0, maxLength - 3) + '...';
}